export default {
  renewal: {
    cta: "Next",
    step_1: {
      category: "Home Value",
      title: "What is the estimated property value of your home?",
      placeholder_value: "$"
    },
    step_2: {
      category: "Home Details",
      title: "What is your property address?",
      placeholder_postalcode: "Postal Code",
      placeholder_province: "Province",
      placeholder_streetaddress: "Street Address",
      placeholder_citytownvillage: "City / Town / Village"
    },
    step_3: {
      category: "Personal Details",
      title: "What is the name and age of the youngest applicant ?",
      placeholder_salutation: "Salutation",
      placeholder_ageinyears: "Age (in years)",
      placeholder_firstname: "First Name",
      placeholder_lastname: "Last Name",
    },
    step_4: {
      category: "Contact Details",
      title: "What is your contact information?",
      placeholder_telephonenumber: "Phone Number",
      placeholder_emailaddress: "Email Address"
    },
    step_5: {
      category: "Timeline Details",
      title: "Have you consulted about getting an Equity Release Mortgage?",
      cta: "NEXT"
    },
    policy: "By continuing, you agree to our <a href='/terms-of-service'>Terms of Service</a> and <a href='/privacy-policy'>Privacy Policy</a>.",
    eligibility: {
      label: "You are eligible to receive up to",
      primaryButtonText: "HOW TO APPLY",
      secondaryButtonText: "Save a PDF report",
      credentialValueLabel: "Value",
      credentialAgeLabel: "Age",
      credentialLocationLabel: "Location"
    },
    thankYou: {
      title: "Thank you",
      description: "An advisor will soon be in contact with you in order to verify your information and estimate your house proprety with you.",
      downloadInformationLabel: "DOWNLOAD INFORMATION"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/renewal.js